import axios from 'axios';
import { put, takeLatest, call } from 'redux-saga/effects';

//types
import * as types from '../ActionTypes/SearchWorkoutActionTypes';
//api
import { workout } from '../../BusinessLogic/Network/API/WorkoutApi';
import { SearchWorkoutsActionCreators } from '../ActionCreators/SearchWorkoutsActionCreators';

export class SearchWorkoutsSaga {
    static *getWorkouts({ meta: { filter } }) {
        try {
            const _workout = workout.create();

            const { data: response } = yield call(axios, _workout.workoutSearchRequest(filter));

            let offsetId = 0;

            if (response.data.length) {
                offsetId = response.data[response.data.length - 1].id;
            }

            yield put(SearchWorkoutsActionCreators.getAllWorkoutSuccess(response.data, offsetId));
        } catch (error) {
            yield put(SearchWorkoutsActionCreators.getWorkoutFail(error));
        }
    }

    static *getMoreWorkouts({ meta: { filter, offsetId } }) {
        try {
            const _workout = workout.create();

            const { data: response } = yield call(axios, _workout.workoutSearchRequest(filter, offsetId));

            if (response.data.length) {
                let offset = response.data[response.data.length - 1].id;
                return yield put(SearchWorkoutsActionCreators.getMoreWorkoutSuccess(response.data, offset));
            }

            return yield put(SearchWorkoutsActionCreators.getMoreUsersEmpty());
        } catch (error) {
            yield put(SearchWorkoutsActionCreators.getWorkoutFail(error));
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_ALL_WORKOUT, SearchWorkoutsSaga.getWorkouts);
    yield takeLatest(types.GET_MORE_WORKOUT, SearchWorkoutsSaga.getMoreWorkouts);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/SearchWorkoutsSaga.js